// extracted by mini-css-extract-plugin
export default {"modal":"ModalPopup_modal__lpgT3","modalContent":"ModalPopup_modalContent__EB8x+","modal_button":"ModalPopup_modal_button__bSf8L"};